module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('font-size-tracker', [_c('div', {
    staticClass: "emblem",
    class: {
      vault: _vm.character.isVault
    }
  }, [_c('div', {
    staticClass: "emblem-inner",
    style: (_vm.styleObject)
  }), _vm._v(" "), _c('div', {
    staticClass: "class-name"
  }, [_vm._v(_vm._s(_vm.character.className))]), _vm._v(" "), _c('div', {
    staticClass: "gender"
  }, [_vm._v(" " + _vm._s(_vm.character.raceName))]), _vm._v(" "), _c('div', {
    staticClass: "level"
  }, [_vm._v(_vm._s(_vm.character.level))]), _vm._v(" "), _c('div', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.character.light))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a1ea8b5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Emblem.vue
// module id = 549
// module chunks = 1